<template>
    <div
        class="CardLayout"
        functional
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'RPCardsLayout',
};
</script>

<style lang="scss">
    .CardLayout {
        display: flex;
        flex-direction: column;
    }
</style>

<docs>
    Displays cards in flex column with consistent spacing.  May provide more utility in the future.
    ```[import](./examples/RPCardsLayoutExample.vue)
    ```
</docs>
